import React from 'react';
import Icon from '../../../components/AppIcon';

const CustomerStatsCard = ({ icon, label, value, trend, trendValue }) => {
  const isPositive = trend === 'up';
  
  return (
    <div className="rounded-lg bg-card p-6 shadow-card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Icon name={icon} size={20} color="var(--color-primary)" />
          </div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="mt-1 text-2xl font-bold text-foreground">{value}</p>
        </div>
        {trend && (
          <div className={`flex items-center space-x-1 rounded-full px-2 py-1 text-xs font-medium ${
            isPositive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerStatsCard;